import React from 'react';
import { SectionCTA } from '../SectionCTA';
const swaps = [{
  from: 'What am I supposed to remember?',
  to: 'Which stage of my workflow am I working through?'
}, {
  from: 'Where do I start?',
  to: 'What does my workflow tell me to organize first?'
}];
export function RepeatableProcess() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-314" data-mp="3vzcpelg4b3wh">
      <div className="mx-auto max-w-3xl" data-id="element-315" data-mp="nihsrnpwyfqu">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-316" data-mp="njjfipgakqoe">
          This isn’t about memorizing more.
          <span className="mt-1 block text-navy-600" data-id="element-317" data-mp="dtggo8mhoii5">
            It’s about building a process you can repeat.
          </span>
        </h2>

        <div className="mt-9 space-y-4" data-id="element-318" data-mp="iqgi268e8x2x">
          {swaps.map(swap => <div key={swap.from} className="grid gap-3 rounded-3xl border border-navy-100 bg-cream p-5 sm:grid-cols-2 sm:gap-5" data-id="element-319" data-mp="16gkm2ephuyug">
              <div data-id="element-320" data-mp="1difm8bwiyc1e">
                <p className="text-[10.5px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-321" data-mp="1djqsqjhctxw7">
                  Instead of asking
                </p>
                <p className="mt-1.5 font-display text-[17px] italic leading-snug text-ink-soft line-through decoration-flag/50" data-id="element-322" data-mp="19faoemne2yj3">
                  “{swap.from}”
                </p>
              </div>
              <div data-id="element-323" data-mp="1ifz5jq82xf07">
                <p className="text-[10.5px] font-bold uppercase tracking-[0.16em] text-go-dark" data-id="element-324" data-mp="1x66nm4u6cw0d">
                  You can ask
                </p>
                <p className="mt-1.5 font-display text-[17px] italic leading-snug text-navy-700" data-id="element-325" data-mp="1s73k4otuexui">
                  “{swap.to}”
                </p>
              </div>
            </div>)}
        </div>

        <p className="mt-8 text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-326" data-mp="21931xjcom5yi">
          That’s the difference between having information…{' '}
          <strong className="font-bold text-ink" data-id="element-327" data-mp="6usdhc001dt9">
            and having a repeatable system for organizing it.
          </strong>
        </p>

        <SectionCTA transformation="Replace recall with a process you trust." label="I want the DVO Workflow Builder™" subline="One-time payment of $27" data-id="element-328" data-mp="26ycoirozw9zm" />
      </div>
    </section>;
}